import { READY_STATE } from "common/constants";
import { oidc } from "services/oidcService";

const getHeaders = async requestInfo => {
  const headers = new Headers({
    "Content-Type": "application/json",
    "Cache-Control": "no-cache"
  });

  if (requestInfo && requestInfo.includeToken) {
    headers.append("Authorization", `Bearer ${await oidc.getAccessToken()}`);
  }

  if (requestInfo && requestInfo.correlationId) {
    headers.append("X-CorrelationId", requestInfo.correlationId);
  }
  return headers;
};

export const checkResponse = async res => {
  const text = await res.text();
  if (!res.ok) {
    throw new Error(`Error ${text}; Status Code: ${res.status} Received from ${res.url}`);
  }
  return text;
};

export const parseJson = text => (text && text.length ? JSON.parse(text) : null);

const rawRequest = async (requestInfo = null, method = "GET", path = "", payload = null) => {
  const options = {
    method,
    headers: await getHeaders(requestInfo),
    mode: "cors",
    responseType: "application/json",
    cache: "default"
  };

  if (payload) {
    options.body = JSON.stringify(payload);
  }

  return fetch(path, options).catch(err => {
    // removing all user specific information for easier grouping of errors in NewRelic
    const pathPattern = path.split("?")[0].replace(/\d+/g, "");
    // throwing my own errors because original fetch errors don't have stack trace
    throw Error(`${err.message} ${method} ${pathPattern}`);
  });
};

const request = (requestInfo = null, method = "GET", path = "", payload = null, parseResponse = true) => {
  return rawRequest(requestInfo, method, path, payload)
    .then(checkResponse)
    .then(parseResponse ? parseJson : res => res);
};

export const GET = (requestInfo, path) => request(requestInfo, "GET", path, null);
export const POST = (requestInfo, path, payload) => request(requestInfo, "POST", path, payload);
export const PATCH = (requestInfo, path, payload) => request(requestInfo, "PATCH", path, payload);
export const PUT = (requestInfo, path, payload) => request(requestInfo, "PUT", path, payload);
export const DELETE = (requestInfo, path) => request(requestInfo, "DELETE", path, null);

export const rawGET = (requestInfo, path) => rawRequest(requestInfo, "GET", path, null);
export const rawPOST = (requestInfo, path, payload) => rawRequest(requestInfo, "POST", path, payload);
export const rawPATCH = (requestInfo, path, payload) => rawRequest(requestInfo, "PATCH", path, payload);
export const rawPUT = (requestInfo, path, payload) => rawRequest(requestInfo, "PUT", path, payload);
export const rawDELETE = (requestInfo, path) => rawRequest(requestInfo, "DELETE", path, null);

export const GET_BLOB = async (requestInfo, path) => {
  var request = new XMLHttpRequest();
  request.open("GET", path, true);

  if (requestInfo && requestInfo.includeToken) {
    request.setRequestHeader("Authorization", `Bearer ${await oidc.getOidcManager().getAccessToken()}`);
  }
  if (requestInfo && requestInfo.correlationId) {
    request.setRequestHeader("X-CorrelationId", requestInfo.correlationId);
  }
  if (requestInfo && requestInfo.headers) {
    requestInfo.headers.forEach(header => {
      request.setRequestHeader(header.name, header.value);
    });
  }
  request.responseType = "blob";

  return new Promise(function(resolve, reject) {
    request.onload = function(event) {
      var blob = this.response;
      resolve(blob);
    };

    request.onreadystatechange = function() {
      if (request.readyState === READY_STATE.DONE && (request.status < 200 || request.status >= 300)) {
        reject({
          status: request.status,
          statusText: request.statusText
        });
      }
    };

    request.send();
  });
};
